// https://ai.google.dev/gemini-api/docs/audio#supported-formats
export const SUPPORTED_AUDIO_GEMINI = {
    "audio/wav": [".wav"],
    "audio/mpeg": [".mp3"],
    "audio/aiff": [".aiff"],
    "audio/aac": [".aac"],
    "audio/ogg": [".oga"],
    "audio/flac": [".flac"],
    // not officially supported by gemini but seems to work
    "audio/webm": [".webm"],
    "video/webm": [".webm"],
    "audio/webm;codecs=opus": [".webm"],
    "audio/mp4": [".m4a", ".mp4"],
    "audio/x-m4a": [".m4a"],
};
export const SUPPORTED_VIDEO_GEMINI = {
    "video/mp4": [".mp4"],
    "video/mpeg": [".mpeg"],
    "video/mov": [".mov"],
    "video/avi": [".avi"],
    "video/x-flv": [".flv"],
    "video/mpg": [".mpg"],
    "video/webm": [".webm"],
    "video/wmv": [".wmv"],
    "video/3gpp": [".3gp", ".3gpp"],
};
export const SUPPORTED_IMAGE_GEMINI = {
    "image/png": [".png"],
    "image/jpeg": [".jpeg", ".jpg"],
    "image/webp": [".webp"],
    "image/heic": [".heic"],
    "image/heif": [".heif"],
};
export const SUPPORTED_DOCUMENT_GEMINI = {
    "application/pdf": [".pdf"],
    "text/plain": [".txt"],
    "text/markdown": [".md"],
    "text/csv": [".csv"],
    "application/rtf": [".rtf"],
};
export var SPEAKER_EMOTION_GEMINI;
(function (SPEAKER_EMOTION_GEMINI) {
    SPEAKER_EMOTION_GEMINI["Happy"] = "happy";
    SPEAKER_EMOTION_GEMINI["Sad"] = "sad";
    SPEAKER_EMOTION_GEMINI["Angry"] = "angry";
    SPEAKER_EMOTION_GEMINI["Neutral"] = "neutral";
})(SPEAKER_EMOTION_GEMINI || (SPEAKER_EMOTION_GEMINI = {}));
export var TRANSCRIPT_TYPE_GEMINI;
(function (TRANSCRIPT_TYPE_GEMINI) {
    TRANSCRIPT_TYPE_GEMINI["AUDIO"] = "AUDIO";
    TRANSCRIPT_TYPE_GEMINI["VIDEO"] = "VIDEO";
    TRANSCRIPT_TYPE_GEMINI["IMAGE"] = "IMAGE";
    TRANSCRIPT_TYPE_GEMINI["PDF_DOCUMENT"] = "DOCUMENT";
    TRANSCRIPT_TYPE_GEMINI["OTHER_DOCUMENT"] = "OTHER_DOCUMENT";
})(TRANSCRIPT_TYPE_GEMINI || (TRANSCRIPT_TYPE_GEMINI = {}));
//# sourceMappingURL=googleAI.js.map